export default __webpack_public_path__ + "static/media/IMG-20240729-WA0012.e963eea5.jpg";